import * as angular from 'angular';
import {IController} from "angular";
import {PdfFormTemplateModel} from "../../models/pdf-form-template.model";

export class PdfFormTemplatesTableComponent implements IController {
  pdfFormTemplates: PdfFormTemplateModel[];
  queryString?: string;
  onDelete: Function;
  onEdit: Function;

  public isScrollable: boolean;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {

  }


  $onChanges(changes) {

  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


}

angular
  .module('bringoz.admin.document-management')
  .component('pdfFormTemplatesTable', {
    bindings: {
      pdfFormTemplates: '<',
      queryString: '<?',
      onDelete: '&',
      onEdit: '&'
    },
    template: require('./pdf-form-templates-table.html').default,
    controller: PdfFormTemplatesTableComponent
  });
